<template>
    <div container--fluid>
        <!-- <v-layout> -->
        <CouponModule :grand-total="grandTotal" :akv="akv" @submitted-voucher="submittedVoucher"></CouponModule>
        <!-- </v-layout> -->
    </div>
</template>

<script>
import CouponModule from "@modules/coupon/index.vue";

export default {
    name: "coupon",
    components: {
        CouponModule,
    },
    props: {
        grandTotal: {
            type: [Number, String],
            required: true,
            default: 0
        },
        akv: {
            type: [Boolean],
            required: false,
            default: true,
        },
    },
    data() {
        return {
            //
        };
    },
    methods: {
        submittedVoucher() {
            this.$emit("submitted-voucher");
        },
    },
};
</script>

<style scoped></style>
